/**
 * Flexible API utility that handles both authenticated and non-authenticated calls
 */
export const apiCall = async ({
  endpoint,
  method = 'GET',
  data = null,
  requiresAuth = false,
  token = null,
  params = null,
}: {
  endpoint: string;
  method?: string;
  data?: any;
  requiresAuth?: boolean;
  token?: string | null;
  params?: Record<string, any> | null;
}) => {
  try {
    // Construct URL with query parameters if provided
    let url = `${process.env.NEXT_PUBLIC_HOST}/api/${endpoint}`;
    if (params) {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, String(value));
        }
      });
      const queryString = queryParams.toString();
      if (queryString) {
        url = `${url}?${queryString}`;
      }
    }

    // Prepare headers
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    // Add auth token if required
    if (requiresAuth) {
      if (!token) {
        const error = new Error('Authentication required but token not provided');
        return { success: false, error };
      }
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Make the request
    const response = await fetch(url, {
      method,
      headers,
      body: data && method !== 'GET' ? JSON.stringify(data) : undefined,
    });

    if (!response.ok) {
      let errorMessage = `API call to ${endpoint} failed: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorMessage;
      } catch (parseError) {}

      const error = new Error(errorMessage);
      return { success: false, error };
    }

    const responseData = await response.json();
    return { success: true, data: responseData };
  } catch (error: any) {
    console.error(`Error in API call to ${endpoint}:`, error);
    return { success: false, error };
  }
};

// User services
export const userServices = {
  // Get subscription status
  getSubscriptionStatus: async (email: string, token: string) => {
    return apiCall({
      endpoint: 'catalog/subscription',
      method: 'GET',
      params: { email },
      requiresAuth: true,
      token,
    });
  },
};
